import { useMutation } from '@tanstack/react-query';

import { llmServiceFetcher } from '../../llm-service/LlmServiceFetcher';

export interface RerunWorkflowParams {
    workflowId: string;
    runId: string;
    resourceId: string;
}

interface RerunWorkflowResponse {
    success: boolean;
    newRunId: string;
    originalRunId: string;
}

export const useRerunWorkflow = () => {
    return useMutation<RerunWorkflowResponse, Error, RerunWorkflowParams>({
        mutationFn: async ({
            workflowId,
            runId,
            resourceId,
        }): Promise<RerunWorkflowResponse> => {
            return await llmServiceFetcher<RerunWorkflowResponse>({
                endpoint: '/workflows/rerun',
                method: 'POST',
                body: JSON.stringify({ workflowId, runId, resourceId }),
            });
        },
    });
};
